import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Javier', 'Carolina', 'Roberto', 'Lucía', 'Ana', 'Diego', 'Gabriela', 'Fernando', 'Silvia', 'Martín', 'Laura', 'Pablo', 'Sofía', 'Alejandro'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán', 'Santa Fe', 'San Juan', 'Neuquén', 'Corrientes', 'Posadas', 'Paraná', 'Jujuy'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    // Loop with random intervals
    const loop = () => {
      const randomInterval = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000); // 8-15 seconds
      setTimeout(() => {
        showNotification();
        loop();
      }, randomInterval);
    };
    loop();
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-23">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 right-4 z-50 max-w-xs w-full bg-white border-l-4 border-green-500 shadow-xl rounded-lg p-4 flex items-center gap-3" data-id="element-24">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-25">
            <CheckCircle className="w-6 h-6 text-green-600" data-id="element-26" />
          </div>
          <div data-id="element-27">
            <p className="text-sm font-medium text-gray-900" data-id="element-28">
              <span className="font-bold" data-id="element-29">{notification.name}</span> de{' '}
              {notification.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-30">acaba de comprar NTICX 360</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}